import type { QueryKey } from "@tanstack/react-query";

/**
 * Maps a mutation to the query key roots its write affects, so it refreshes only what it changed.
 *
 * A mutation with no entry here invalidates every query, which is always safe and the right default for a
 * new write. Listing roots is an optimization rather than a correctness fix, and a missed root leaves stale
 * data on screen — see `README.md` for how this tier relates to the other two.
 */

// The action routes return a full Device but never touch connectedSensors, so they can't change the streams.
const DEVICE_ONLY: QueryKey[] = [["devices"]];

export const mutationInvalidationTargets: Record<string, QueryKey[]> = {
    setDeviceOperatingMode: DEVICE_ONLY,
    clearDeviceVerification: DEVICE_ONLY,
    clearDeviceWarnings: DEVICE_ONLY,
    runDeviceNetworkTest: DEVICE_ONLY,

    // Zone writes don't change zone ids, so they don't invalidate any other resource queries.
    createZone: [["zones"]],
    updateZone: [["zones"]],
    deleteZone: [["zones"]],

    // Site writes don't change site ids, so they don't invalidate any other resource queries.
    createSite: [["sites"]],
    updateSite: [["sites"]],
    deleteSite: [["sites"]],

    // A test send writes no subscription state; all it moves is the throttle floor the availability query
    // under this root reports.
    sendNotificationSubscriptionTest: [["notification-subscriptions"]],
    // The numbers table reads which groups are off from the subscription list, not the contact list.
    setNotificationSubscriptionEnabled: [["notification-subscriptions"]],

    putLockoutBanner: [["lockout-banners"]],
};
